import { combineReducers } from "redux";

import blog from "./reducers/blogReducer";
import articleReducer from "./reducers/innerBlogReducer";

export default combineReducers({
    'blog': blog,
    'blogArticle': articleReducer,
});